import React from 'react';

import ClipLoader from 'react-spinners/ClipLoader';

import { COLORS } from '../../styles/constants';
import { Container } from './styles';

interface LoadingContainerProps {
  style?: React.CSSProperties;
  color?: string;
}

const LoadingContainer: React.FC<LoadingContainerProps> = ({
  style,
  color,
}) => {
  return (
    <Container style={style}>
      <ClipLoader size={100} color={color || COLORS.primary} />
    </Container>
  );
};

export default LoadingContainer;
